'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n\n  width: 100%;\n  padding: 8px\n\n  border-bottom: 2px solid ', ';\n  box-sizing: border-box;\n'], ['\n  position: relative;\n\n  width: 100%;\n  padding: 8px\n\n  border-bottom: 2px solid ', ';\n  box-sizing: border-box;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: calc(100% - 24px);\n  height: 32px;\n  padding: 2px;\n\n  font-size: 16px;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: ', ';\n\n  &::placeholder {\n    color: ', ';\n  }\n'], ['\n  width: calc(100% - 24px);\n  height: 32px;\n  padding: 2px;\n\n  font-size: 16px;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: ', ';\n\n  &::placeholder {\n    color: ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 8px;\n  right: 8px;\n\n  margin: 0;\n  padding: 0;\n\n  font-size: 24px;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  cursor: pointer;\n  color: ', ';\n  background: ', ';\n'], ['\n  position: absolute;\n  top: 8px;\n  right: 8px;\n\n  margin: 0;\n  padding: 0;\n\n  font-size: 24px;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  cursor: pointer;\n  color: ', ';\n  background: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _variables = require('../../styles/variables');

var _variables2 = _interopRequireDefault(_variables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputContainer = _styledComponents2.default.div(_templateObject, _variables2.default.LIGHT_GREY);

var Input = _styledComponents2.default.input(_templateObject2, _variables2.default.BLACK, _variables2.default.LIGHT_GREY);

var ClearButton = _styledComponents2.default.button(_templateObject3, _variables2.default.LIGHT_GREY, _variables2.default.WHITE);

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.onInputChange = function (e) {
      _this.props.onChange(e.target.value);
    }, _this.onClearClick = function () {
      _this.props.onChange('');
      _this.focusInput();
    }, _this.focusInput = function () {
      _this.inputRef.focus();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.focusInput();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        InputContainer,
        null,
        _react2.default.createElement(Input, {
          onChange: this.onInputChange,
          value: this.props.value,
          placeholder: 'Search icons',
          innerRef: function innerRef(node) {
            _this2.inputRef = node;
          }
        }),
        _react2.default.createElement(
          ClearButton,
          {
            onClick: this.onClearClick
          },
          '\xD7'
        )
      );
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  value: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func
};
_class.defaultProps = {
  onChange: function onChange() {}
};
exports.default = _class;